import React, {
  Fragment,
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FacetedSearchCompact from './FacetedSearchCompact';
import { AccordionPanel, Accordion } from '../Components/Accordion';
import { query } from '../Actions/FacetedSearch.action';
import SubNav from './SubNavCompact';
import SortCriteriaCompact from './SortCriteriaCompact';
import FilterTag from './FilterTags';
import { translate } from '../Services/translation';
import { updateFilterOption } from '../Actions/FacetedSearch.action';
import { PRODUCT_VIEW_CACHED } from '../constants';

const FacetedSearchCompactContainer = () => {
  const dispatch = useDispatch();
  const {
    subNavigation,
    sortCriteria,
    facetFilters: globalFacetFilters,
    navigationTheme,
    productsViewCachedId,
  } = useSelector((state) => state.productFiltering);

  const [facetFilters, setFacetFilters] = useState(globalFacetFilters || []);
  const [selectedFacetFilters, setSelectedFacetFilters] = useState(
    globalFacetFilters || []
  );
  const previousCachedId = useRef(productsViewCachedId);
  useEffect(() => {
    if (previousCachedId.current !== productsViewCachedId) {
      setFacetFilters(globalFacetFilters);
      setSelectedFacetFilters(globalFacetFilters);
      previousCachedId.current = productsViewCachedId;
    }
  }, [globalFacetFilters, productsViewCachedId]);

  useEffect(() => {
    dispatch(query(window.location.search.substr(1) || '', false));
  }, [dispatch]);

  const onFacetChange = useCallback(
    (filter, option) => {
      setFacetFilters((prevFacetFilters) => {
        return updateFilterOption(prevFacetFilters, filter, option);
      });
    },
    [setFacetFilters]
  );

  const onSearchResultDataChange = (dom) => {
    if ([null, undefined].includes(dom)) {
      return;
    }

    const mobileClass = '.hide-for-large';
    const desktopClass = '.show-for-large';
    let elementKey = document.activeElement?.getAttribute('data-key') ?? '';
    let mobileQuery = mobileClass + ' [data-key="' + elementKey + '"]';
    let desktopQuery = desktopClass + ' [data-key="' + elementKey + '"]';
    let elementQuery =
      document.querySelector(mobileQuery) == document.activeElement
        ? mobileQuery
        : document.querySelector(desktopQuery) == document.activeElement
        ? desktopQuery
        : null;

    const container = document.createElement('div');
    container.innerHTML = dom;

    const replace = (node, newNode) =>
      node.parentNode.replaceChild(newNode, node);

    replace(
      document.querySelector('#search-result #MVCGridTable_CustomProductsGrid'),
      container.querySelector('#search-result #MVCGridTable_CustomProductsGrid')
    );
    replace(
      document.querySelector('#search-result ul.pagination'),
      container.querySelector('#search-result ul.pagination')
    );
  };

  useEffect(() => {
    const productViewCached = window.__litium.cache
      ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {}
      : {};
    if (!productViewCached.used) {
      productViewCached.used = true;
      const dom = productViewCached.productsView;
      dom && onSearchResultDataChange(dom);
    }
  });

  const empty = (array) => !(array && array.length);

  const subNavigations = !subNavigation ? null : [subNavigation];
  const sortCriterias =
    !sortCriteria || !sortCriteria.sortItems ? null : sortCriteria.sortItems;

  const hidden = [subNavigations, facetFilters, sortCriterias].every((arr) =>
    empty(arr)
  );

  return hidden ? null : (
    <Fragment>
      <FilterTag
        {...{
          facetFilters: selectedFacetFilters,
          navigationTheme: navigationTheme || '',
        }}
      />
      <Accordion className="compact-filter hide-for-large">
        {!empty(subNavigations) && (
          <AccordionPanel header={translate('facet.header.categories')}>
            <SubNav {...{ subNavigation: subNavigations }} />
          </AccordionPanel>
        )}
        {!empty(facetFilters) && (
          <AccordionPanel header={translate('facet.header.filter')}>
            <FacetedSearchCompact
              {...{
                facetFilters,
                onFacetChange,
              }}
            />
          </AccordionPanel>
        )}
        {!empty(sortCriterias) && (
          <AccordionPanel header={translate('facet.header.sortCriteria')}>
            <SortCriteriaCompact {...{ sortCriteria: sortCriterias }} />
          </AccordionPanel>
        )}
      </Accordion>
      {navigationTheme === 'category' && (
        <div className="compact-filter category-theme show-for-large">
          <FacetedSearchCompact
            {...{
              facetFilters,
              onFacetChange,
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

export default FacetedSearchCompactContainer;
